var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClock2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14131_346)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19.1666C15.0626 19.1666 19.1667 15.0626 19.1667 9.99998C19.1667 4.93737 15.0626 0.833313 10 0.833313C4.93743 0.833313 0.833374 4.93737 0.833374 9.99998C0.833374 15.0626 4.93743 19.1666 10 19.1666ZM11.1459 5.989C11.1459 5.35618 10.6329 4.84317 10 4.84317C9.36721 4.84317 8.85421 5.35618 8.85421 5.989V11.1453C8.85421 11.5048 9.02298 11.8435 9.31002 12.06C9.59707 12.2765 9.96911 12.3458 10.3148 12.247L14.3252 11.1012C14.9337 10.9273 15.2861 10.2931 15.1122 9.68464C14.9384 9.07616 14.3041 8.72382 13.6957 8.89767L11.1459 9.62619V5.989Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14131_346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClock2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Clock_2.c2a3f9e5aff462778893ff045827faf1.svg";